/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StagingRecordDto } from './StagingRecordDto';
import {
    StagingRecordDtoFromJSON,
    StagingRecordDtoFromJSONTyped,
    StagingRecordDtoToJSON,
    StagingRecordDtoToJSONTyped,
} from './StagingRecordDto';

/**
 * 
 * @export
 * @interface StagingRecordDtoPagedResponseDto
 */
export interface StagingRecordDtoPagedResponseDto {
    /**
     * 
     * @type {Array<StagingRecordDto>}
     * @memberof StagingRecordDtoPagedResponseDto
     */
    items?: Array<StagingRecordDto> | null;
    /**
     * 
     * @type {number}
     * @memberof StagingRecordDtoPagedResponseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof StagingRecordDtoPagedResponseDto
     */
    pageIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof StagingRecordDtoPagedResponseDto
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the StagingRecordDtoPagedResponseDto interface.
 */
export function instanceOfStagingRecordDtoPagedResponseDto(value: object): value is StagingRecordDtoPagedResponseDto {
    return true;
}

export function StagingRecordDtoPagedResponseDtoFromJSON(json: any): StagingRecordDtoPagedResponseDto {
    return StagingRecordDtoPagedResponseDtoFromJSONTyped(json, false);
}

export function StagingRecordDtoPagedResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StagingRecordDtoPagedResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(StagingRecordDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'pageIndex': json['pageIndex'] == null ? undefined : json['pageIndex'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function StagingRecordDtoPagedResponseDtoToJSON(json: any): StagingRecordDtoPagedResponseDto {
    return StagingRecordDtoPagedResponseDtoToJSONTyped(json, false);
}

export function StagingRecordDtoPagedResponseDtoToJSONTyped(value?: StagingRecordDtoPagedResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(StagingRecordDtoToJSON)),
        'totalCount': value['totalCount'],
        'pageIndex': value['pageIndex'],
        'pageSize': value['pageSize'],
    };
}

